import React from 'react';

import { ArtistFundraisingPickCreate } from './ArtistFundraisingPickCreate';
import { ArtistFundraisingPickUpdate } from './ArtistFundraisingPickUpdate';

import { useCurrentArtistProfile } from '../../utils';

import { useAuthorized } from '../lib';
import type { Alertable } from './types';

function useShouldShowArtistFundraisingPick() {
  const authorized = useAuthorized();

  return authorized;
}

export function ArtistFundraisingPick(props: Alertable) {
  const shouldShow = useShouldShowArtistFundraisingPick();

  const artistProfile = useCurrentArtistProfile();

  if (!shouldShow) return null;

  const artistFundraisingPick = artistProfile?.artistFundraisingPick;

  if (artistFundraisingPick == null) {
    return <ArtistFundraisingPickCreate />;
  }

  return (
    <ArtistFundraisingPickUpdate
      url={artistFundraisingPick.url}
      setAlert={props.setAlert}
    />
  );
}
